<template>
  <g
    :class="['arrow-marker-group', { 'arrow-marker-group--rotating': rotating }]"
    :aria-label="ariaLabel"
  >
    <!-- 回転 UI: ダウンロード時は html-to-image の filter / scoped CSS が
         SVG 子孫に届かず映り込むため、v-if で DOM から除外する -->
    <template v-if="!isExporting">
      <!-- rotation stem hit area (invisible, wider for easier hover) -->
      <line
        class="rotation-stem-hitarea"
        data-testid="rotation-stem-hitarea"
        :x1="x"
        :y1="y"
        :x2="stemEndX"
        :y2="stemEndY"
        stroke="transparent"
        :stroke-width="12 * sizeScale"
      />
      <!-- rotation stem -->
      <line
        class="rotation-stem"
        data-testid="rotation-stem"
        :x1="x"
        :y1="y"
        :x2="stemEndX"
        :y2="stemEndY"
        stroke="#333"
        :stroke-width="1.5 * sizeScale"
      />
      <!-- rotation handle -->
      <circle
        class="rotation-handle"
        data-testid="rotation-handle"
        :cx="stemEndX"
        :cy="stemEndY"
        :r="handleRadius"
        :fill="color"
        stroke="black"
        :stroke-width="2 * sizeScale"
        @mousedown.stop="$emit('rotation-start', $event)"
      />
    </template>

    <!-- arrow -->
    <g
      :transform="arrowTransform"
      class="arrow-shape"
      v-on="$listeners"
    >
      <svg
        :x="-markerSize / 2"
        :y="-markerSize / 2"
        :width="markerSize"
        :height="markerSize"
        :viewBox="VIEWBOX"
      >
        <path
          data-testid="arrow-marker-shape"
          :d="PATH"
          :fill="color"
          stroke="black"
          :stroke-width="STROKE_WIDTH"
        />
      </svg>
    </g>
  </g>
</template>

<script>
import {
  ARROW_MARKER_PATH,
  ARROW_MARKER_VIEWBOX,
  ARROW_MARKER_STROKE_WIDTH,
} from './arrowMarkerShape';

const STEM_LENGTH_AT_BASE = 30;
const HANDLE_RADIUS_AT_BASE = 6;

export default {
  name: 'ArrowMarker',
  inheritAttrs: false,
  props: {
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    rotation: {
      type: Number,
      default: 0,
    },
    markerSize: {
      type: Number,
      required: true,
    },
    sizeScale: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    rotating: {
      type: Boolean,
      default: false,
    },
    isExporting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stemLength() {
      return STEM_LENGTH_AT_BASE * this.sizeScale;
    },
    handleRadius() {
      return HANDLE_RADIUS_AT_BASE * this.sizeScale;
    },
    stemEndX() {
      const rad = ((this.rotation - 90) * Math.PI) / 180;
      return this.x + Math.cos(rad) * this.stemLength;
    },
    stemEndY() {
      const rad = ((this.rotation - 90) * Math.PI) / 180;
      return this.y + Math.sin(rad) * this.stemLength;
    },
    arrowTransform() {
      return `translate(${this.x}, ${this.y}) rotate(${this.rotation})`;
    },
  },
  created() {
    this.PATH = ARROW_MARKER_PATH;
    this.VIEWBOX = ARROW_MARKER_VIEWBOX;
    this.STROKE_WIDTH = ARROW_MARKER_STROKE_WIDTH;
  },
};
</script>

<style scoped>
.arrow-marker-group .rotation-stem,
.arrow-marker-group .rotation-handle {
  opacity: 0;
  transition: opacity 0.15s;
  cursor: crosshair;
}

.arrow-marker-group:hover .rotation-stem,
.arrow-marker-group:hover .rotation-handle,
.arrow-marker-group--rotating .rotation-stem,
.arrow-marker-group--rotating .rotation-handle {
  opacity: 1;
}

.arrow-shape {
  cursor: crosshair;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}
</style>
